import { Deal } from '../types';
import { z } from 'zod';

// Dev builds read the dev feed written by local deals-processor runs.
const DEALS_URL = import.meta.env.DEV
  ? 'https://assets.share-a-cart.com/deals/deals-dev.json'
  : 'https://assets.share-a-cart.com/deals/deals.json';

const dealSchema: z.ZodType<Deal, z.ZodTypeDef, unknown> = z.object({
  retailer: z.string(),
  retailerDisplayName: z.string().nullish().transform(v => v ?? null),
  name: z.string(),
  description: z.string().nullable(),
  link: z.string(),
  // Stale deals.json may predate this field — default instead of rejecting.
  linkTemplate: z.string().nullish().transform(v => v ?? null),
  code: z.string().nullable(),
  image_url: z.string().nullable(),
  featured: z.boolean(),
  // Stale deals.json may predate these fields — default instead of rejecting.
  wrapAffil: z.boolean().optional().default(false),
  school: z.boolean().optional().default(false),
  effective_at: z.string().nullable(),
  expires_at: z.string().nullable(),
});

const dealsResponseSchema = z.object({
  deals: z.array(dealSchema),
});

export const getDeals = async (): Promise<Deal[]> => {
  const res = await fetch(DEALS_URL);
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`Error fetching deals: HTTP ${res.status}${body ? ` — ${body}` : ''}`);
  }
  const data = await res.json();
  return dealsResponseSchema.parse(data).deals;
};
